import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store";

interface FleetState {
  bulkActionStatus: string | null;
  showBulkConfirmModal: boolean;
  resultModal: {
    show: boolean;
    type: "success" | "error" | "warning";
    title: string;
    message: string;
  };
  // Session State
  searchValue: string;
  statusFilter: string;
  vehicleTypeFilter: string;
  vehicleModelFilter: string;
  currentPage: number;
  rowsPerPage: number;
}

const initialState: FleetState = {
  bulkActionStatus: null,
  showBulkConfirmModal: false,
  resultModal: {
    show: false,
    type: "success",
    title: "",
    message: "",
  },
  searchValue: "",
  statusFilter: "",
  vehicleTypeFilter: "",
  vehicleModelFilter: "",
  currentPage: 1,
  rowsPerPage: 10,
};

const fleetSlice = createSlice({
  name: "fleet",
  initialState,
  reducers: {
    setBulkAction: (state, action: PayloadAction<{ status: string | null; showModal: boolean }>) => {
      state.bulkActionStatus = action.payload.status;
      state.showBulkConfirmModal = action.payload.showModal;
    },
    showResultModal: (state, action: PayloadAction<{ type: "success" | "error" | "warning"; title: string; message: string }>) => {
      state.resultModal = { ...action.payload, show: true };
    },
    hideResultModal: (state) => {
      state.resultModal.show = false;
    },
    setSearchValue: (state, action: PayloadAction<string>) => {
      state.searchValue = action.payload;
      state.currentPage = 1;
    },
    setStatusFilter: (state, action: PayloadAction<string>) => {
      state.statusFilter = action.payload;
      state.currentPage = 1;
    },
    setVehicleTypeFilter: (state, action: PayloadAction<string>) => {
      state.vehicleTypeFilter = action.payload;
      state.currentPage = 1;
    },
    setVehicleModelFilter: (state, action: PayloadAction<string>) => {
      state.vehicleModelFilter = action.payload;
      state.currentPage = 1;
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setRowsPerPage: (state, action: PayloadAction<number>) => {
      state.rowsPerPage = action.payload;
      state.currentPage = 1;
    },
    resetFleetState: () => initialState,
  },
});

export const {
  setBulkAction,
  showResultModal,
  hideResultModal,
  setSearchValue,
  setStatusFilter,
  setVehicleTypeFilter,
  setVehicleModelFilter,
  setCurrentPage,
  setRowsPerPage,
  resetFleetState,
} = fleetSlice.actions;



export default fleetSlice.reducer;
